import {CollectResultsService} from "@vicman-wi/telemetry-js/esm/collect-results/CollectResultsService";
import {stringIsTrueValue} from "@vicman-wi/utils-js/esm/string/is-true-value";
import {stringToNumbers} from "@vicman-wi/utils-js/esm/string/to-numbers";
import logger from "./logger";

let instance = null;

/** @return {CollectResultsService} */
export function getCollectResultsService() {
  if (instance) return instance;

  const userGroups = stringToNumbers(process.env.REACT_APP_RESULTS_COLLECT_USER_GROUPS);

  instance = new CollectResultsService(
    {
      isEnabled: stringIsTrueValue(
        process.env.REACT_APP_RESULTS_COLLECT_ENABLED
      ),
      isMuted: userGroups.indexOf(window.clientConfig.splitGroupId) === -1,
      projectName: window.appConfig.project.name,
      clientToken: window.clientConfig.token,
    },
    logger()
  );

  return instance;
}